import React from 'react';
import { DatePicker } from 'antd';

const { RangePicker } = DatePicker;

/**
 * antd's range picker, for the coupon form's Start/End date field — the same widget the old
 * coupon UI (`profile/Coupan.js`) and the Edit Program modal (`ProgramForm/ui/Inputs.js`) use.
 *
 * Scoped to this page rather than sharing `ProgramForm`'s `RangeInput`: same reasoning as
 * `CouponSelect`'s private `cpn_select` prefix — a private popup class here keeps one page's
 * portalled styling from reaching into another's.
 */
const POPUP_CLASS = 'coupon-form-popup';
const toBody = () => document.body;

const RangeInput = p => (
    <RangePicker id={p.id} getPopupContainer={toBody} dropdownClassName={POPUP_CLASS} {...p} />
);

export default RangeInput;
